import { render, staticRenderFns } from "./ConfermaRiunione.vue?vue&type=template&id=6788798b&scoped=true&"
import script from "./ConfermaRiunione.vue?vue&type=script&lang=js&"
export * from "./ConfermaRiunione.vue?vue&type=script&lang=js&"
import style0 from "./ConfermaRiunione.vue?vue&type=style&index=0&id=6788798b&prod&scoped=true&lang=css&"
import style1 from "./ConfermaRiunione.vue?vue&type=style&index=1&id=6788798b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788798b",
  null
  
)

export default component.exports